import { UploadIcon } from "@solomon-apps/shared";
import React from "react";

import type { ChartDataPoint } from "../data/chartData";
import { formatCurrencyFull } from "../utils/formatters";

import { ChartArea } from "./ChartArea";

export interface ChartCardProps {
    title: string;
    data: ChartDataPoint[];
    kpiValue: number;
    formatter: (value: number) => string;
    onShare: () => void;
}

export function PrimaryChartCard({
    title,
    data,
    kpiValue,
    formatter,
    onShare
}: ChartCardProps): React.ReactElement {
    return (
        <div className="flex flex-col gap-3">
            {/* Title bar */}
            <div className="flex items-center bg-m-surface-muted p-3 md:p-6">
                <div className="flex flex-col xl:flex-row xl:items-center gap-1 xl:gap-4 flex-1 min-w-0">
                    <h2 className="text-2xl lg:text-3xl text-m-foreground whitespace-nowrap">
                        {title}
                    </h2>
                    <p
                        className="text-2xl lg:text-3xl text-m-accent"
                        style={{ fontFamily: '"APK Narrative"' }}
                    >
                        {formatCurrencyFull(kpiValue)}
                    </p>
                </div>
                <button
                    onClick={onShare}
                    className="w-8 h-8 shrink-0 flex items-center justify-center transition-colors text-gray-400 hover:text-m-accent cursor-pointer"
                    aria-label={`Share ${title}`}
                    title="Share"
                >
                    <UploadIcon />
                </button>
            </div>
            {/* Chart */}
            <div className="bg-m-surface-base pl-1 md:pl-3 pb-2 pt-6 md:pb-4 pr-4 lg:pr-2">
                <ChartArea title={title} data={data} formatter={formatter} />
            </div>
        </div>
    );
}
